import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import BulkSearchModal from '@/views/components/bulkSearchModal/index.vue';
import DetailModal from './detailModal/index.vue';

var LogisticsAgentAbnormalListPage = function (_super) {
  __extends(LogisticsAgentAbnormalListPage, _super);

  function LogisticsAgentAbnormalListPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.total = 0;
    _this.docValue = '';
    _this.columns = [];
    _this.selectedList = [];
    _this.editData = {};
    _this.rowSelection = {};
    _this.searchData = _this.initSearchData();
    _this.searchParam = _this.initSearchData();
    _this.data = [];
    _this.domesticLogisticsProductList = [];
    _this.internationalTransitionWarehouseList = [];
    _this.domesticTransitionWarehouseList = [];
    _this.warehouseList = [];
    _this.loadingStatus = false;
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition();
    _this.productCodeLocalEnum = [];
    _this.warehouseTypeEnum = [];
    _this.clearanceTypeEnum = [];
    _this.statusEnum = [];
    _this.deliveryTypeEnum = [];
    return _this;
  }

  Object.defineProperty(LogisticsAgentAbnormalListPage.prototype, "domesticTransitionWarehouseGroup", {
    get: function get() {
      var obj = {};
      var list = this.$util.objArrayUnique(this.domesticTransitionWarehouseList, 'wp_code');
      list.forEach(function (item) {
        if (!obj[item.country_code]) {
          obj[item.country_code] = {};
          obj[item.country_code].country = item.country;
          obj[item.country_code].country_code = item.country_code;
          obj[item.country_code].transition_warehouse_list = [];
        }

        obj[item.country_code].transition_warehouse_list.push(item);
      });
      return obj;
    },
    enumerable: false,
    configurable: true
  });

  LogisticsAgentAbnormalListPage.prototype.onDatetimeDefaultValueChange = function (arr) {
    if (arr.length) {
      this.searchData.start_time = this.$util.formatDateTime(arr[0]);
      this.searchData.end_time = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.start_time = '';
      this.searchData.end_time = '';
    }
  };

  LogisticsAgentAbnormalListPage.prototype.initSearchData = function () {
    return {
      fba_order_type: undefined,
      product_code: undefined,
      sm_code: undefined,
      transit_warehouse_code: undefined,
      warehouse_type: undefined,
      delivery_type: undefined,
      customs: undefined,
      clearance: undefined,
      wp_code: undefined,
      value_array: [],
      search_keyword: this.$enum.internationalDelivery.LogisticsAgentKeyWord.LOGISTICS_AGENT_CODE,
      rectime_type: this.$enum.internationalDelivery.LogisticsAgentTimeType.CREATE_TIME,
      start_time: '',
      end_time: '',
      page_index: 1,
      page_size: 20
    };
  };

  LogisticsAgentAbnormalListPage.prototype.getList = function () {
    this.rowSelection.selectedRowKeys = this.selectedList = [];
    this.queryList(this.searchData);
  };

  LogisticsAgentAbnormalListPage.prototype.queryList = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.searchParam = this.$util.deepCopy(params);
            this.total = null;
            return [4, this.$api.internationalDelivery.queryLogisticsAgentAbnormalList(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.data = res.data.list;
              this.total = res.data.total;
            }

            return [2];
        }
      });
    });
  };

  LogisticsAgentAbnormalListPage.prototype.cancelBulk = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.internationalDelivery.discardLogisticsAgent(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.$message.success(this.t('废弃成功'));
              this.getList();
            }

            return [2];
        }
      });
    });
  };

  LogisticsAgentAbnormalListPage.prototype.submitLogisticsAgentAgain = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.internationalDelivery.submitLogisticsAgentAgain(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.$message.success(this.t('提交成功'));
              this.getList();
            }

            return [2];
        }
      });
    });
  };

  LogisticsAgentAbnormalListPage.prototype.queryDomesticTransitionWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.internationalDelivery.queryTransitWarehouse({})];

          case 1:
            res = _a.sent();
            this.domesticTransitionWarehouseList = res.data || [];
            return [2];
        }
      });
    });
  };

  LogisticsAgentAbnormalListPage.prototype.queryDomesticLogisticsProductList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.common.querySmList()];

          case 1:
            res = _a.sent();
            this.domesticLogisticsProductList = res.data.map(function (item) {
              return {
                sm_code: item.sm_code,
                sm_code_name: item.sm_name
              };
            });
            return [2];
        }
      });
    });
  };

  LogisticsAgentAbnormalListPage.prototype.handleChangeStatus = function () {
    this.searchData.page_index = 1;
    this.getList();
  };

  LogisticsAgentAbnormalListPage.prototype.handleTimeChange = function (date) {
    this.searchData.start_time = this.$util.formatDateTime(date[0]);
    this.searchData.end_time = this.$util.formatDateTime(date[1]);
  };

  LogisticsAgentAbnormalListPage.prototype.handleSearch = function () {
    return __awaiter(this, void 0, Promise, function () {
      var value;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            value = this.docValue ? this.docValue.split(',') : [];
            this.searchData.page_index = 1;
            this.searchData.value_array = value;
            return [4, this.getList()];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  LogisticsAgentAbnormalListPage.prototype.handleClear = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _this = this;

      return __generator(this, function (_a) {
        this.docValue = '';
        this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
        this.searchData = this.initSearchData();
        this.$nextTick(function () {
          _this.getList();
        });
        return [2];
      });
    });
  };

  LogisticsAgentAbnormalListPage.prototype.handleDblClick = function () {
    var bulkSearchRef = this.$refs.bulkSearchModal;
    bulkSearchRef.modalVisible = true;
    bulkSearchRef.bulkListStr = this.docValue;
  };

  LogisticsAgentAbnormalListPage.prototype.handlePageChange = function (page, pageSize) {
    this.searchData.page_index = page;
    this.searchData.page_size = pageSize;
    this.getList();
  };

  LogisticsAgentAbnormalListPage.prototype.handleBulkFeedback = function (bulkKeywords) {
    this.docValue = bulkKeywords;
  };

  LogisticsAgentAbnormalListPage.prototype.handleSelectedAbandon = function () {
    var _this = this;

    if (!this.selectedList.length) {
      this.$message.warn(this.t('common', '请选择废弃项'));
    } else {
      this.$confirm({
        title: this.tc('温馨提示'),
        content: this.t('请确认是否废弃？'),
        onOk: function onOk() {
          _this.cancelBulk({
            gc_fba_order_code: _this.selectedList
          });
        }
      });
    }
  };

  LogisticsAgentAbnormalListPage.prototype.handleAbandon = function (record) {
    var _this = this;

    this.$confirm({
      title: this.tc('温馨提示'),
      content: this.t('请确认是否废弃？'),
      onOk: function onOk() {
        _this.cancelBulk({
          gc_fba_order_code: [record.gc_fba_order_code]
        });
      }
    });
  };

  LogisticsAgentAbnormalListPage.prototype.handleSubmit = function (record) {
    var _this = this;

    this.$confirm({
      title: this.tc('温馨提示'),
      content: this.t('请确认是否提交？'),
      onOk: function onOk() {
        _this.submitLogisticsAgentAgain({
          gc_fba_order_code: record.gc_fba_order_code
        });
      }
    });
  };

  LogisticsAgentAbnormalListPage.prototype.handleSuccessReload = function () {
    this.getList();
  };

  LogisticsAgentAbnormalListPage.prototype.handleEdit = function (record) {
    this.$router.push({
      name: 'EditLogisticsAgentPage',
      query: {
        order_type: String(record.fba_order_type),
        code: record.gc_fba_order_code,
        is_abnormal: 'true'
      }
    });
  };

  LogisticsAgentAbnormalListPage.prototype.handleViewReason = function (data) {
    this.editData = data;
    var detailModalRef = this.$refs.detailModalRef;
    detailModalRef.visible = true;
  };

  LogisticsAgentAbnormalListPage.prototype.created = function () {
    var _this = this;

    this.columns = [{
      title: this.t('单号'),
      name: 'code',
      disabled: true,
      width: 300,
      scopedSlots: {
        customRender: 'code'
      }
    }, {
      title: this.t('Shipment ID'),
      name: 'shipment_id',
      dataIndex: 'shipment_id',
      filterEmpty: true,
      width: 120
    }, {
      title: this.t('状态'),
      name: 'status',
      dataIndex: 'status_text',
      width: 120
    }, {
      title: this.t('运输方式'),
      name: 'product_code_text',
      width: 150,
      dataIndex: 'product_code_text'
    }, {
      title: this.t('目的国'),
      name: 'country_code',
      width: 150,
      scopedSlots: {
        customRender: 'country_code'
      }
    }, {
      title: this.t('目的仓'),
      name: 'warehouse_type_text',
      width: 120,
      dataIndex: 'warehouse_type_text',
      filterEmpty: true
    }, {
      title: this.t('送仓类型'),
      name: 'fba_order_type_text',
      dataIndex: 'fba_order_type_text'
    }, {
      title: this.t('物流产品'),
      name: 'sm_code',
      dataIndex: 'sm_code',
      width: 150,
      scopedSlots: {
        customRender: 'sm_code'
      }
    }, {
      title: this.t('异常类型'),
      name: 'exception_type_text',
      dataIndex: 'exception_type_text',
      filterEmpty: true,
      checked: true
    }, {
      title: this.t('异常原因'),
      name: 'exception_surface_info',
      checked: true,
      filterEmpty: true,
      width: 180,
      scopedSlots: {
        customRender: 'exception_surface_info'
      }
    }, {
      title: this.t('时间'),
      name: 'time',
      dataIndex: 'time',
      scopedSlots: {
        customRender: 'time'
      },
      width: 220
    }, {
      title: this.t('操作'),
      name: 'operation',
      key: 'operation',
      showColumnSetting: true,
      width: 200,
      fixed: 'right',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: function onChange(selectedRowKeys) {
        _this.rowSelection.selectedRowKeys = _this.selectedList = selectedRowKeys;
      }
    };
    this.queryDomesticTransitionWarehouseList();
    this.queryDomesticLogisticsProductList();
    this.$nextTick(function () {
      _this.getList();
    });
  };

  __decorate([enumData('LogisticsAgent/ProductCodeLocalEnum')], LogisticsAgentAbnormalListPage.prototype, "productCodeLocalEnum", void 0);

  __decorate([enumData('LogisticsAgent/WarehouseTypeEnum')], LogisticsAgentAbnormalListPage.prototype, "warehouseTypeEnum", void 0);

  __decorate([enumData('LogisticsAgent/ClearanceTypeEnum')], LogisticsAgentAbnormalListPage.prototype, "clearanceTypeEnum", void 0);

  __decorate([enumData('LogisticsAgent/StatusEnum')], LogisticsAgentAbnormalListPage.prototype, "statusEnum", void 0);

  __decorate([enumData('LogisticsAgent/DeliveryTypeEnum')], LogisticsAgentAbnormalListPage.prototype, "deliveryTypeEnum", void 0);

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], LogisticsAgentAbnormalListPage.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([userPrefPageSize('logisticsAgentAbnormalList')], LogisticsAgentAbnormalListPage.prototype, "initSearchData", null);

  __decorate([loading('loadingStatus')], LogisticsAgentAbnormalListPage.prototype, "queryList", null);

  LogisticsAgentAbnormalListPage = __decorate([Component({
    components: {
      BulkSearchModal: BulkSearchModal,
      DetailModal: DetailModal
    }
  })], LogisticsAgentAbnormalListPage);
  return LogisticsAgentAbnormalListPage;
}(Vue);

export default LogisticsAgentAbnormalListPage;